export const STOREFRONT_BANNER_MIN_COVER_ASPECT_RATIO = 1.5;
export const STOREFRONT_BANNER_MAX_COVER_ASPECT_RATIO = 4.5;

export function getImageAspectRatio(image) {
  const metadata = image?.metadata?.image || {};
  const width = Number(metadata.width || metadata.originalWidth);
  const height = Number(metadata.height || metadata.originalHeight);

  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return null;
  }

  return width / height;
}

export function getStorefrontBannerDisplayMode(image) {
  const aspectRatio = getImageAspectRatio(image);
  if (aspectRatio === null) return 'cover';

  return aspectRatio < STOREFRONT_BANNER_MIN_COVER_ASPECT_RATIO
    || aspectRatio > STOREFRONT_BANNER_MAX_COVER_ASPECT_RATIO
    ? 'contain'
    : 'cover';
}
